import { useEffect, useState } from 'react';
import { get } from "superagent";

import './App.css';
import "react-datepicker/dist/react-datepicker.css";
import SharedView from './components/shared/index';
import { Form } from './types';
import { fetchForms } from './helpers';

function App() {

  const [user, setUser] = useState<any>(null);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [forms, setForms] = useState<Form[]>([]);
  const [isValidating, setIsValidating] = useState<boolean>(true);

  const validateUser = async () => {
    try {
      setIsValidating(true);
      // Validate LTI
      const response = await get(`${process.env.REACT_APP_API_URL}/validate-user`).withCredentials();

      // Check if the response body contains courseGuid and role
      const { courseGuid, role, userId } = response.body;
      if (courseGuid) {
        // Save courseGuid to sessionStorage
        sessionStorage.setItem('courseGuid', courseGuid);
      } else {
        console.warn("No courseGuid in validate-user response.");
        return; // Exit if no courseGuid
      }

      if (userId) {
        sessionStorage.setItem('userId', userId);
      } else {
        console.warn("No userId in validate-user response.");
      }

      if (role) {
        sessionStorage.setItem('role', role);
      } else {
        console.warn("No role in validate-user response.");
      }

      // Set user data and mark as ready
      setUser({ ...response.body, role, userId });
      setIsReady(true);
    } catch (err) {
      console.error("Error in validateUser:", err);
    } finally {
      setIsValidating(false);
    }
  };

  const refreshForms = async () => {
    if (isValidating) return; // Don't fetch forms while validating
    
    try {
      const courseGuid = sessionStorage.getItem('courseGuid');
      if (!courseGuid) {
        console.warn("No courseGuid available for form fetch");
        return;
      }
      const fetchedForms = await fetchForms(courseGuid);
      setForms(fetchedForms);
    } catch (err) {
      console.error('Error refreshing forms:', err);
    }
  };

  useEffect(() => {
    validateUser();
  }, []);

  // Separate useEffect for form fetching that depends on validation completion
  useEffect(() => {
    if (!isValidating && isReady) {
      refreshForms();
    }
  }, [isValidating, isReady]);

  if (isValidating) {
    return <div>Loading...</div>; // Show loading state while validating
  }

  if (isReady) {

    if (user) {
        return (
          <SharedView
          forms={forms}
          setForms={setForms}
          refreshForms={refreshForms}
          />
        );
    }

    return (
      <div className="App">
        <header className="App-header">
          No session
        </header>
      </div>
    );

  }

  return null;

}

export default App;

